import React, { memo } from 'react';

const MovieRow = memo(({movie, onClick}) => {
    // Extract rating information
    const userScore = movie.rating?.userScore?.score || null;
    const pressScore = movie.rating?.pressScore?.score || null;
    const wantToSee = movie.rating?.wantToSee || 0;
    
    // Format runtime
    const formatRuntime = (runtime) => {
        if (!runtime) return '';
        const match = runtime.match(/(\d+)h(\d+)?/);
        if (match) {
            const hours = match[1];
            const minutes = match[2] || '00';
            return `${hours}h${minutes}`;
        }
        return runtime;
    };

    // Get primary genre
    const primaryGenre = movie.genres?.[0] || '';

    return (
        <div onClick={onClick}
             key={movie.id}
             className="flex items-center justify-between p-3 bg-white border-b border-gray-100 hover:bg-gray-50 transition-colors cursor-pointer"
        >
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                    <h5 className="text-sm font-semibold text-gray-900 truncate">
                        {movie.title}
                    </h5>
                    {movie.ageRestriction && (
                        <span className="text-xs px-1.5 py-0.5 bg-gray-200 text-gray-700 rounded">
                            {movie.ageRestriction}
                        </span>
                    )}
                </div>
                
                <div className="flex items-center gap-3 text-xs text-gray-600">
                    {movie.productionYear && (
                        <span>{movie.productionYear}</span>
                    )}
                    {movie.runtime && (
                        <span>{formatRuntime(movie.runtime)}</span>
                    )}
                    {primaryGenre && (
                        <span className="truncate">{primaryGenre}</span>
                    )}
                    {movie.director?.firstName && movie.director?.lastName && (
                        <span className="truncate">
                            {movie.director.firstName} {movie.director.lastName}
                        </span>
                    )}
                </div>
            </div>

            <div className="flex items-center gap-2 ml-3 shrink-0">
                {/* User Score */}
                {userScore && (
                    <div className="text-center">
                        <div className="text-xs font-bold text-blue-600">
                            {userScore}/5
                        </div>
                        <div className="text-xs text-gray-500">Spectateurs</div>
                    </div>
                )}
                
                {/* Press Score */}
                {pressScore && (
                    <div className="text-center">
                        <div className="text-xs font-bold text-green-600">
                            {pressScore}/5
                        </div>
                        <div className="text-xs text-gray-500">Presse</div>
                    </div>
                )}
                
                {/* Want to See */}
                {wantToSee > 0 && (
                    <div className="text-center">
                        <div className="text-xs font-bold text-purple-600">
                            {wantToSee}
                        </div>
                        <div className="text-xs text-gray-500">Vœux</div>
                    </div>
                )}
                
                {/* Showtimes count */}
                {movie.showtimes && Object.keys(movie.showtimes).length > 0 && (
                    <div className="text-center">
                        <div className="text-xs font-bold text-orange-600">
                            {Object.keys(movie.showtimes).length}
                        </div>
                        <div className="text-xs text-gray-500">Cinémas</div>
                    </div>
                )}
            </div>
        </div>
    );
});

MovieRow.displayName = 'MovieRow';

export default MovieRow;